import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import EnhancedSecurity from '../components/enhanced-security-view';
import {
  meData,
  meEnhancedSecurity,
  meRequestPatch,
  meTfaEnrolled,
  meIsConflicted,
} from 'modules/me-module';
import environment from 'lib/environment';
import {uiShowToastrMessage} from "modules/ui-module";
import auth from "lib/profile-auth";
import Session from 'lib/session';
import appconfig from "config/appconfig";

const serviceUrl = environment.get().api.serviceUrl;

export class EnhancedSecurityContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      personData: Object.assign({}, this.props.personData),
      errors: {},
      isDirty: false,
    };
  }

  displayToastrMessage = (toastrType, toastrMessageId) => {
    this.props.uiShowToastrMessage(toastrType, toastrMessageId);
  };

  getEnrollmentURL = (addSetupParam) => {
    let redirectURL = location.href;
    if (addSetupParam) {
      redirectURL += (location.search ? '&' : '?') + appconfig.storage.enhancedSecuritySetup + '=1';
    }
    return `${serviceUrl}enroll2fa?service=${encodeURIComponent(redirectURL)}`;
  }

  setUpEnhancedSecurity = () => () => {
    Session.setItem(appconfig.storage.enhancedSecuritySetup, '1');
    const enrollmentURL = this.getEnrollmentURL(true);
    window.location.assign(enrollmentURL);
    return false;
  }

  toggleEnhancedSecurity = () => () => {
    const enhancedSecurityEnabled = !this.props.meEnhancedSecurity;
    const payload = {};
    payload[appconfig.scimSchemas.getGo] = {enhancedSecurity: enhancedSecurityEnabled};
    return this.props.meRequestPatch(payload).then(
      () => {
        this.displayToastrMessage('success', 'enhanced-security.enhanced-security-save-successful');
        const forceReload = !!(auth.token && auth.token.loa !== 3);
        if (enhancedSecurityEnabled && forceReload) { // if the enhanced security setting was set to true and the current loa is not 3, force MFA login.
          Session.setItem('minLoa', '3');
          auth.clear();
          window.location.assign(window.location.href.split('?')[0]);
        }
      },
      () => {
        this.displayToastrMessage('error', 'enhanced-security.enhanced-security-save-failed');
      },
    );
  }

  render() {
    return (
      <EnhancedSecurity
        setUpEnhancedSecurityOnClick={this.setUpEnhancedSecurity()}
        toggleEnhancedSecurity={this.toggleEnhancedSecurity}
        resetDeviceOnClick={this.getEnrollmentURL(false)}
        meEnhancedSecurity={this.props.meEnhancedSecurity}
        meTfaEnrolled={this.props.meTfaEnrolled}
        isViewOnly={this.props.isViewOnly}
      />
    );
  }
}

EnhancedSecurityContainer.propTypes = {
  personData: PropTypes.object.isRequired,
  meEnhancedSecurity: PropTypes.bool.isRequired,
  meTfaEnrolled: PropTypes.bool.isRequired,
  meRequestPatch: PropTypes.func.isRequired,
  uiShowToastrMessage: PropTypes.func.isRequired,
  isViewOnly: PropTypes.bool,
};

export const mapStateToProps = (state) => ({
  personData: meData(state),
  meEnhancedSecurity: meEnhancedSecurity(state),
  meTfaEnrolled: meTfaEnrolled(state),
  isViewOnly: meIsConflicted(state),
});

export const mapDispatchToProps = (dispatch) => ({
  meRequestPatch: (payload) => dispatch(meRequestPatch(payload)),
  uiShowToastrMessage: (toastrType, toastrMessageId) => dispatch(uiShowToastrMessage(toastrType, toastrMessageId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EnhancedSecurityContainer);
